/************* ALL ACTIONS TYPES ARE HERE ****************/

// types for dashboard
export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';

//types for auth
export const UPDATE_AUTH = "UPDATE_AUTH";
export const EMPTY_AUTH = "EMPTY_AUTH";

//types for user
export const UPDATE_USER_REDUCER = "UPDATE_USER";

//types for user detail
export const UPDATE_USERS_LOADING = "UPDATE_USERS_LOADING";
export const UPDATE_USERS_LIST_DATA = "UPDATE_USERS_LIST_DATA";
export const UPDATE_USER_DETAIL_REDUCER = "UPDATE_USER_DETAIL_REDUCER";

//types for cms
export const CMS_LIST = "CMS_LIST";

// types for sites
export const UPDATE_SITES_LIST = "UPDATE_SITES_LIST";
export const UPDATE_SITES_LOADING = "UPDATE_SITES_LOADING";

// types for sites
export const UPDATE_CITIES_LIST = "UPDATE_CITIES_LIST";
export const UPDATE_CITIES_LOADING = "UPDATE_CITIES_LOADING";

// types for reports
export const UPDATE_REPORTS_USER_LIST = "UPDATE_REPORTS_USER_LIST";
export const UPDATE_REPORTS_USER_LIST_LOADING =
  "UPDATE_REPORTS_USER_LIST_LOADING";
export const UPDATE_REPORTED_USER_DETAILS = "UPDATE_REPORTED_USER_DETAILS";
export const UPDATE_REPORTEDBY_USER_LIST = "UPDATE_REPORTEDBY_USER_LIST";
export const UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_USER =
  "UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_USER";

export const UPDATE_REPORTS_POST_LIST = "UPDATE_REPORTS_POST_LIST";
export const UPDATE_REPORTED_POST_DETAILS = "UPDATE_REPORTED_POST_DETAILS";
export const UPDATE_REPORTEDBY_USER_LIST_FOR_POST =
  "UPDATE_REPORTEDBY_USER_LIST_FOR_POST";
export const UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_POST =
  "UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_POST";
export const UPDATE_REPORTS_POST_LIST_LOADING =
  "UPDATE_REPORTS_POST_LIST_LOADING";

export const UPDATE_FEEDBACK_LIST = "UPDATE_FEEDBACK_LIST";
export const UPDATE_FEEDBACK_LOADING = "UPDATE_FEEDBACK_LOADING";
export const UPDATE_FEEDBACK_DETAILS = "UPDATE_FEEDBACK_DETAILS";

//types for queries
export const UPDATE_QUERIES_LOADING = "UPDATE_QUERIES_LOADING";
export const UPDATE_QUERIES_LIST_DATA = "UPDATE_QUERIES_LIST_DATA";

// export const UPDATE_REPORTS_LOADING = "UPDATE_REPORTS_LOADING";
